export const EXPENSE_PERMISSION_MODULE = 'Expense';

/**
 * Frontend permission keys used in Expense UI/guards.
 * Match BE actionPermissions.action names from /my → companyPermissions.
 */
export const ExpenseAction = {
  Create: 'Create',
  View: 'View',
  Submit: 'Submit',
  Comment: 'Comment',
  UpdateDraft: 'UpdateDraft',
  Withdraw: 'Withdraw',
  EditApprovedOrPaymentPending: 'EditApprovedOrPaymentPending',
  DeleteDraft: 'DeleteDraft',
  Return: 'Return',
  Reject: 'Reject',
  Approve: 'Approve',
  Update: 'Update',
  /** BE actionPermissions.action — /my → companyPermissions */
  IntegrateToAP: 'IntegrateToAP',
  /** Standalone Expense (no sync to AP): pay the request from the detail page. */
  MakePayment: 'MakePayment',
} as const;

export type ExpenseActionName =
  (typeof ExpenseAction)[keyof typeof ExpenseAction];

/** Raw action names returned by /my → companyPermissions.actionPermissions */
export const ExpenseBackendAction = {
  Create: 'Create',
  View: 'View',
  Submit: 'Submit',
  Comment: 'Comment',
  UpdateDraft: 'UpdateDraft',
  Withdraw: 'Withdraw',
  EditApprovedOrPaymentPending: 'EditApprovedOrPaymentPending',
  DeleteDraft: 'DeleteDraft',
  Return: 'Return',
  Reject: 'Reject',
  Approve: 'Approve',
  Update: 'Update',
  IntegrateToAP: 'IntegrateToAP',
  MakePayment: 'MakePayment',
} as const;
